export const ECOM_PLATFORM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';

/** @deprecated */
export const petriSpecs = {
  FixCartNavigationOnPreview: 'specs.ecom.FixCartNavigationOnPreview'
};
export const conductorSpecs = {};
export const SPECS = {
  ...petriSpecs,
  ...conductorSpecs
};
//# sourceMappingURL=consts.js.map